module.exports = __webpack_public_path__ + "static/media/sign_up_step1_cover.d1d2b1aa.png";